import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=a0db8fa0&"
import script from "./UserManagement.vue?vue&type=script&lang=js&"
export * from "./UserManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports